import {addTaskToBatch} from '../myTasks.action';
import { getTasksWithPaymentActionExtraData } from "components/store/application.reducers.js";

export function addTaskToBundle(taskKey) {
    addTaskToBatch(taskKey);
}

export function tasksWithPaymentData(taskIds) {
    return function(dispatch, getState) {
        const state = getState();
        return getTasksWithPaymentActionExtraData(taskIds, state);
    };
}